import React from 'react';

import {
  PasswordChangeFormValues,
  PasswordChangeFormViolation,
} from 'types/passwordChangeFormTypes';
import { createPasswordChangeFormViolationLense } from 'utils/passwordChangeFormUtils';

const initialValues: PasswordChangeFormValues = {
  currentPassword: '',
  nextPassword: '',
  nextPasswordRepeat: '',
};

export const usePasswordChangeForm = () => {
  const [values, setValues] = React.useState<PasswordChangeFormValues>(
    initialValues
  );

  const [violations, setViolations] = React.useState<
    PasswordChangeFormViolation[]
  >([]);

  const setCurrentPassword = React.useCallback((nextValue: string) => {
    setValues((prevValues) => ({
      ...prevValues,
      currentPassword: nextValue,
    }));

    setViolations((prev) =>
      prev.filter(
        (violation) =>
          !createPasswordChangeFormViolationLense(
            violation
          ).isCurrentPasswordViolation()
      )
    );
  }, []);

  const setNextPassword = React.useCallback((nextValue: string) => {
    setValues((prevValues) => ({
      ...prevValues,
      nextPassword: nextValue,
    }));

    setViolations((prev) =>
      prev.filter(
        (violation) =>
          !createPasswordChangeFormViolationLense(
            violation
          ).isNextPasswordViolation()
      )
    );
  }, []);

  const setNextPasswordRepeat = React.useCallback((nextValue: string) => {
    setValues((prevValues) => ({
      ...prevValues,
      nextPasswordRepeat: nextValue,
    }));

    setViolations((prev) =>
      prev.filter(
        (violation) =>
          !createPasswordChangeFormViolationLense(
            violation
          ).isNextPasswordRepeatViolation()
      )
    );
  }, []);

  return {
    values,
    violations,
    setValues,
    setViolations,
    setCurrentPassword,
    setNextPassword,
    setNextPasswordRepeat,
  };
};
